import $api from 'http'
import { loadIdentityResponse } from './LoadIdentityService'

// Read-only API endpoints for reports (is_report_of users)

export async function getReportGuards(params) {
  return $api.get('/tabel/report/guards/', { params })
}

export async function getReportTopBases(params) {
  return $api.get('/tabel/report/top-bases/', { params })
}

export async function getReportChpps(params) {
  return $api.get('/tabel/report/chpps/', { params })
}

export async function getReportPrivatePoints(params) {
  return $api.get('/tabel/report/private-points/', { params })
}

export async function getReportTopBaseOperators(topBaseId, params) {
  return $api.get(`/tabel/report/top-bases/${topBaseId}/operators/`, { params })
}

export async function getReportChppOperators(chppId, params) {
  return $api.get(`/tabel/report/chpps/${chppId}/operators/`, { params })
}

export async function getReportPrivatePointOperators(privatePointId, params) {
  return $api.get(`/tabel/report/private-points/${privatePointId}/operators/`, { params })
}

export async function getReportTopBaseDrivers(topBaseId, params) {
  return $api.get(`/tabel/report/top-bases/${topBaseId}/drivers/`, { params })
}

export async function getReportChppDrivers(chppId, params) {
  return $api.get(`/tabel/report/chpps/${chppId}/drivers/`, { params })
}

export async function getReportPrivatePointDrivers(privatePointId, params) {
  return $api.get(`/tabel/report/private-points/${privatePointId}/drivers/`, { params })
}

export async function getReportTopBaseBranches(topBaseId, params) {
  return $api.get(`/tabel/report/top-bases/${topBaseId}/branches/`, { params })
}

export async function getReportChppBranches(chppId, params) {
  return $api.get(`/tabel/report/chpps/${chppId}/branches/`, { params })
}

export async function getReportPrivatePointBranches(privatePointId, params) {
  return $api.get(`/tabel/report/private-points/${privatePointId}/branches/`, { params })
}

export async function getReportAllDrivers(params) {
  return $api.get('/tabel/report/drivers/', { params })
}

export async function getReportDriverDetail(id) {
  return $api.get(`/tabel/report/drivers/${id}/`)
}

export async function getReportRequests(params) {
  return $api.get('/tabel/report/requests/', { params })
}

export async function getReportRequestStatistics(params) {
  return $api.get('/tabel/report/request-statistics/', { params })
}

export async function getReportRequestHistory(params) {
  return $api.get('/tabel/report/request-history/', { params })
}

export async function getReportAllBranches(params) {
  return $api.get('/tabel/report/branches/', { params })
}

export async function getReportLoadingsStatistics(params) {
  return $api.get('/tabel/report/loadings-statistics/', { params })
}

export async function getReportTopDriversByLoads() {
  return $api.get('/tabel/report/top-drivers-by-loads/')
}

export async function getLoadsInLoading(params) {
  return $api.get('/tabel/loads-in-loading/', { params }).then(loadIdentityResponse)
}

export async function getLoadsInRoute(params) {
  return $api.get('/tabel/loads-in-route/', { params }).then(loadIdentityResponse)
}

export async function getLoadsCompleted(params) {
  return $api.get('/tabel/loads-completed/', { params }).then(loadIdentityResponse)
}

export async function getRecentLoads(params) {
  return $api.get('/tabel/loads-in-route/', { params }).then(loadIdentityResponse)
}
